// extracted by mini-css-extract-plugin
export default {"termsContainer":"Term_n_condition_termsContainer__6Y+5k","termsHeader":"Term_n_condition_termsHeader__nqgyX","content":"Term_n_condition_content__W8Lh5"};